/******/ (() => { // webpackBootstrap
/*!***************************************!*\
  !*** ./zrc/scripts/sections/logos.js ***!
  \***************************************/
class Logos extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.optimizeImages();
    this.logosCarrusel();
  }
  optimizeImages() {
    var sUsrAg = window.navigator.userAgent;
    if (sUsrAg.indexOf("Chrome") > -1) {
      document.querySelector(".homepage-logos-content").classList.add("optimize-icon");
    }
  }
  logosCarrusel() {
    var slidesLength = $(".homepage-logos-slider").data("slides");
    var autoplay = $(".homepage-logos-slider").data("autoplay");
    var speed = $(".homepage-logos-slider").data("speed");
    $(".homepage-logos-slider").slick({
      arrows: false,
      autoplay: slidesLength > 4 ? autoplay : false,
      autoplaySpeed: slidesLength > 4 ? speed : 0,
      centerMode: false,
      infinite: slidesLength > 4,
      pauseOnFocus: false,
      pauseOnHover: false,
      slidesToScroll: 1,
      slidesToShow: 4,
      variableWidth: false,
      responsive: [{
        breakpoint: 661,
        settings: {
          autoplay: slidesLength > 3 ? autoplay : false,
          autoplaySpeed: slidesLength > 3 ? speed : 0,
          centerMode: slidesLength > 3,
          infinite: slidesLength > 3,
          slidesToShow: 3,
          variableWidth: true
        }
      }, {
        breakpoint: 391,
        settings: {
          autoplay: slidesLength > 2 ? autoplay : false,
          autoplaySpeed: slidesLength > 2 ? speed : 0,
          centerMode: slidesLength > 2,
          centerPadding: "0px",
          infinite: slidesLength > 2,
          slidesToShow: slidesLength > 2 ? 1 : 2,
          variableWidth: true
        }
      }]
    });
  }
}
if (window.customElements.get("logos-section") == null) {
  window.customElements.define("logos-section", Logos);
}
/******/ })()
;